import { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { authContext } from "../../context/AuthContext";
import * as Yup from 'yup'; 
import Get from "../../api/Get";
import { COMPANY_ALL_ACTIVE, USUARIOS_GET_BY_ID, USUARIOS_SAVE } from "../../api/Routes";
import LoadingList from "../../loader/LoadingList";
import { Field, Formik } from "formik";
import Post from "../../api/Post";
import { useHistory } from "react-router";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { CustomSelect } from "../CustomSelect";
import { Link } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'
import es from 'react-phone-input-2/lang/es.json'
import 'react-phone-input-2/lib/style.css'
import ComponentModalErrorSever from "../ComponentModalErrorSever";

function FormUsuario({t, id}){
    const [loading, setLoading] = useState(id ? true: false)
    const {auth} = useContext(authContext)
    const [textLoad, setTextoLoad] = useState("Cargando...")
    const history = useHistory()
    const [companyOpt, setCompanyOpt] = useState([])
    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }  
    const roles = [
        {
            value: 1,
            label: "Admin"
        },
        {
            value: 4,
            label: "Operator"
        },
        {
            value: 5,
            label: "AdminDoctor"
        },
        {
            value: 6,
            label: "AdminOperation"
        },
        // {
        //     value: 2,
        //     label: "Doctor"
        // },
        // {
        //     value: 3,
        //     label: "Patient"
        // },
        {
            value: 7,
            label: "Calidad"
        },
        // {
        //     value: 8,
        //     label: "Consultorio"
        // }
    ]
    const [phone, setPhone] = useState('')

    const [initialValues, setInitialValues] = useState({
        id: '',
        name: '',
        active: true,
        email: "",
        password: "",
        roles: '',
        userType: '',
        phoneNumber: '',
        company: ''
    })

    const shemaValidate = Yup.object().shape({
        name: Yup.string()
            .required('Campo Requerido'),
        phoneNumber: Yup.string().required('Campo requerido')
          .min(12,'Campo inválido')
          .max(12,'Campo inválido'),
        company: Yup.string()
           .required(t('Camporequerido')),
        roles: Yup.string().required('Campo requerido'), 
        email:Yup.string()
                    .email("Correo electrónico no válido")   
                    .required('Campo requerido'),       
        password:Yup.string().when('id', {
            is: value => value,
            then: Yup.string()
                        .notRequired(),
            otherwise: Yup.string().required('Campo requerido'),
        })
    });

    useEffect(() => {
        if(id){
            setTextoLoad("Cargando...")
            setLoading(true)
            Get({url: `${USUARIOS_GET_BY_ID}/${id}`, access_token: auth.data.access_token})
            .then( resp => {
                let data = resp.data.data
                let entity = {
                    id: data.id,
                    name: data.name,
                    active: data.active,
                    email: data.email,
                    roles: data.roles.length > 0 ? data.roles.map(el=>(el.id))[0] : null,
                    phoneNumber: data.phoneNumber,
                    company: data.company ? data.company.id : '',                
                }              
                //console.log(data.roles.map(el=>({label: el.name, value: el.id}))) 
                setPhone(data.phoneNumber)
                setInitialValues(entity)
                setLoading(false)

            })
            .catch( error => {
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoading(false)

            } )
        }

        Get({url: COMPANY_ALL_ACTIVE, access_token: auth.data.access_token})
        .then(response=>{
            setCompanyOpt(response.data.data.response)
        })
        .catch( error => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)

        })
    }, [])

    return (
        <>
        {
            loading ? <LoadingList texto={textLoad} /> :
            <Formik initialValues={initialValues}
                validationSchema={shemaValidate}
                onSubmit={(values, { setSubmitting, setFieldValue,setFieldError }) => { 
                    //console.log(values)
                    
                    let rols = roles.filter(elem =>  elem.value === values.roles)
                    let data = Object.assign({}, values) 
                    data['roles'] = rols.map(el=>({id: el.value})) 
                    data['userType'] = rols[0].label  
                    data['company'] = {id: values.company}         
                    console.log(data)

                    Post({url: USUARIOS_SAVE, data: data, access_token: auth.data.access_token, header: true})
                    .then(response=>{
                        setSubmitting(false)
                        history.replace("/admin/usuarios")
                    })
                    .catch(error=>{
                        setShowModalServer(true)
                        if(error.response){
                            setErrorServer(error.response)
                        }
                        setSubmitting(false)
                    })
                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                setFieldError
            }) => (
                <Form onSubmit={handleSubmit}  className='mt-3'>
                    {isSubmitting && <LoadingList texto="Procesando solicitud"/>}
                    <input type="hidden" name="id" value={values.id} />
                    <Card className="shadow-1-2 formSection">
                        <Card.Body>
                            <Row>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label>Nombre <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.name && 'error'}`}
                                            name="name"
                                        />
                                        { errors.name && <div className="invalid-feedback d-block">{errors.name}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label>Teléfono <span className="text-danger">*</span></Form.Label>
                                        <PhoneInput
                                            inputClass={`form-control input-form ${errors.phoneNumber && 'error'} w-100`}
                                            country={'mx'}
                                            countryCodeEditable={false}
                                            enableSearch={true}
                                            preferredCountries={['mx', 'co']}
                                            disableSearchIcon={true}
                                            localization={es}
                                            value={phone}
                                            onChange={(phone, country, e, formattedValue) => {
                                                setPhone(phone)
                                                setFieldValue('phoneNumber', phone)
                                                let validNumber = (country.format.match(/\./g)).length
                                                if(phone.length !== validNumber){
                                                    setFieldError('phoneNumber', 'Campo inválido')
                                                }else if(phone.length === validNumber){
                                                    setFieldValue('phoneNumber', phone, true)
                                                }                                                
                                            }}
                                        />
                                        { errors.phoneNumber && <div className="invalid-feedback d-block">{errors.phoneNumber}</div> }                                      
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="2">
                                    <Form.Group className="mt-5">
                                        <div className="form-check">
                                            <Field 
                                                type="checkbox"
                                                className={`form-check-input`}
                                                name="active"
                                            />
                                            <label className="form-check-label">Activo</label>
                                        </div>                                        
                                    </Form.Group>
                                </Col>
                            </Row> 
                            <Row>
                                <Col xs="12" md="6">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary">{t('compania')} <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            as="select"
                                            className={`form-control input-form ${errors.company && 'error'}`}
                                            name="company"
                                        >
                                            <option value="">{t('Seleccionar')}</option>
                                            {
                                                companyOpt.map((item,i)=>(
                                                    <option value={item.id} key={i}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        { errors.company && <div className="invalid-feedback d-block">{errors.company}</div> }
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label>Correo electrónico/Usuario <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="text"
                                            className={`form-control input-form ${errors.email && 'error'}`}
                                            name="email"
                                        />
                                        { errors.email && <div className="invalid-feedback d-block">{errors.email}</div> }
                                    </Form.Group>
                                </Col>
                                {!id && <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label>Contraseña <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            type="password"
                                            className={`form-control input-form ${errors.password && 'error'}`}
                                            name="password"
                                        />
                                        { errors.password && <div className="invalid-feedback d-block">{errors.password}</div> }
                                    </Form.Group>
                                </Col>}
                                <Col xs="12" md="4">
                                    <Form.Group>
                                        <Form.Label>Roles <span className="text-danger">*</span></Form.Label>
                                        <Field 
                                            className={`component-select ${errors.roles && 'error'}`}
                                            name="roles"
                                            options={roles}
                                            component={CustomSelect}
                                            placeholder="Seleccionar role"
                                            isMulti={false}
                                        />
                                        { errors.roles && <div className="invalid-feedback d-block">{errors.roles}</div> }
                                    </Form.Group>
                                </Col>
                            </Row>                         
                        </Card.Body>
                    </Card>
                    
                    <Row className="mt-4">
                        <Col className="text-right">
                            <Link to="/admin/usuarios" className="cancelar-buttom btn btn-outline-danger font-weight-bold text-white">Cancelar</Link>{' '}
                            <Button variant="outline-success" className="ok-buttom font-weight-bold" type="submit">{id ? 'Editar' : 'Crear'}</Button>
                        </Col>
                    </Row>

                    <ComponentModalErrorSever
                        show={showModalServer}
                        handleClose={handleCloseModalServer}
                        error={errorServer}
                    />
                </Form>
            )}
        </Formik>
        }        
        </>
    )

}

export default withTranslation()(FormUsuario)